import { new_error} from "../confg";
import {createAction} from "@reduxjs/toolkit";

export const errorAction=createAction(new_error);
